(() => {
  "use strict";

  const COUNTRIES   = "#country-analysis-countries";
  const FESPS       = "#country-analysis-fesp";
  const FILTERS     = "#analysis-filters";
  const STRATEGIES  = "#country-analysis-strategies";
  const I18N_LABELS = {
    "es": {
      "all_options":        "Todos/Todas",
      "installed_capacity": "Capacidad Instalada",
      "not_evaluation":     "No se ha iniciado la evaluación para los filtros aplicados"
    },
    "en": {
      "all_options":        "All",
      "installed_capacity": "Existing Capacity",
      "not_evaluation":     "Evaluation has not started for applied filters"
    }
  };

  var charts = {};

  //
  var getLabel = (label) => {
    let current_lang = document.getElementsByTagName('html')[0].getAttribute('lang');

    return I18N_LABELS[current_lang][label];
  };

  //
  var generateFullUrl = (route) => {
    let url = window.location

    return `${url.protocol}//${url.host}${route}`;
  };

  //
  var drawChart = (json, title, id_element="fesp_barchart") => {
    let colors = { 1: '#93CAC5', 2: '#82C0D9', 3: '#2B678C', 4: '#147ab7', 5: '#114a95' };

    if (charts[id_element] !== undefined) {
      charts[id_element].destroy();
    }

    charts[id_element] = new Chart(document.getElementById(id_element).getContext("2d"), {
      type: 'horizontalBar',
      data: {
        labels: json.map((el) => { return el[0] }),
        datasets: [{
          label: getLabel('installed_capacity'),
          backgroundColor: json.map((el) => { return colors[el[1]] }),
          borderColor: [],
          data: json.map((el) => { return el[1] })
        }]
      },
      options: {
        title: {
          display: true,
          text: title
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero:true,
              precision: 0,
              stepSize: 1,
              suggestedMax: 5
            }
          }]
        }
      }
    });
  };

  //
  var getStrategies = (evaluation_id, current_filter) => {
    let jfilter = $(current_filter);

    if (jfilter.data("filter-country-analysis") === "fesp" && jfilter.find("option:selected").data("strategy-filter")) {
      let url = new URL(`${generateFullUrl($(FILTERS).data('url-strategies')).replace('__ID__', evaluation_id)}`);

      fetch(url).then((response) => {
        return response.json();
      }).then((json) => {
        let new_html = `<option value="0">${getLabel('all_options')}</option>`;

        $(json.strategies).each((k,v) => {
          new_html += `<option value=${v.id}>${v.translations[0].question}</option>`;
        });

        $(STRATEGIES).html(new_html);
      });
    }
  };

  //
  var getGraphInformation = (evaluation_id, title=undefined, validate=true, id_element="fesp_barchart") => {
    let url = new URL(`${generateFullUrl($(FILTERS).data('url-graph')).replace('__ID__', evaluation_id)}`),
        params = { strategy: $(STRATEGIES).val() };
    url.search = new URLSearchParams(params).toString();
    
    if (title === undefined) {
      title = $(FESPS).find('option:selected').html();
    }

    fetch(url).then((response) => {
      return response.json();
    }).then((json) => {
      if (json.length === 0 && validate) {
        swal(getLabel('not_evaluation'));
      } else {
        drawChart(json, title, id_element);
      }
    });
  };

  //
  var getGaps = (evaluation_id) => {
    let url = new URL(`${generateFullUrl($(FILTERS).data('url-gaps')).replace('__ID__', evaluation_id)}`),
        params = { strategy: $(STRATEGIES).val() };
    url.search = new URLSearchParams(params).toString();

    fetch(url).then((response) => {
      return response.json();
    }).then((json) => {
      let fesp = $(FESPS).find('option:selected').html().toLowerCase(),
          i18n_gaps = $("#table-gaps").data('translations'),
          detail_gaps = '',
          summary_gaps = '';

      $(json.gaps).each((k, v) => {
        summary_gaps += `<tr>
          <td style="background-color: ${json.type_capacities[v.capacity_id][0].capacity_bgcolor}; color: ${json.type_capacities[v.capacity_id][0].capacity_textcolor};">${v.capacity}</td>
          <td class="text-right">${v.gaps.length} / ${json.total_gaps[v.capacity_id][0].total_gaps}</td>
        </tr>`;
        
        $(v.gaps).each((i, val) => {
          detail_gaps += `<tr>
            <td style="background-color: ${json.type_capacities[v.capacity_id][0].capacity_bgcolor}; color: ${json.type_capacities[v.capacity_id][0].capacity_textcolor};">${v.capacity}</td>
            <td>${val.strategy_text}</td>
            <td>${(fesp === 'fesp10') ? i18n_gaps[fesp][val.type_capacity_id][val.strategy_code][val.criterion] : i18n_gaps[fesp][val.type_capacity_id][val.criterion]}</td>
            <td>
              <a class="text-warning" href="/tracking_gaps/new?evaluation_header=${evaluation_id}&capacity=${val.type_capacity_id}&strategy=${val.strategy_code}&criterion=${val.criterion}"><i class= "fas fa-pencil-alt"></i></a>
            </td>
          </tr>`;
        });
      });

      $("#summary-gaps tbody").html(summary_gaps);
      $("#table-gaps tbody").html(detail_gaps);
    });
  };

  // Get last evaluations from country and FESP
  var getLastEvaluations = (current_filter) => {
    let url = new URL(`${generateFullUrl($(FILTERS).data('url-last-eval'))}`),
        params = { country: $(COUNTRIES).val(), fesp: $(FESPS).val() };
    url.search = new URLSearchParams(params).toString();
        
    fetch(url).then((response) => {
      return response.json()
    }).then((json) => {
      $(json).each((k,v) => {
        getStrategies(v.id, current_filter);
        getGaps(v.id);
        getGraphInformation(v.id);
      });
    });
  };
  
  // Enable/Disable strategy filter based on data-strategy-filter attribute of the constant 'FESPS' field
  var enableStrategyFilter = (current_filter) => {
    let jfilter = $(current_filter);
    $(STRATEGIES).parent().addClass('d-none');

    if (jfilter.data("filter-country-analysis") === "fesp" && jfilter.find("option:selected").data("strategy-filter")) {
      $(STRATEGIES).parent().removeClass('d-none');
    }
  };

  // Reload drawAllFespCountry
  var reloadDrawAllFespCountry = (current_filter) => {
    let jfilter = $(current_filter);

    if (jfilter.data("filter-country-analysis") === "countries") {
      $("#charts_all_fesps div").each((k, v) => {
        $(v).addClass('d-none');
      });
      drawAllFespCountry();
    }
  };

  // Observer for changes in filter lists
  var changeFilters = (els="[data-filter-country-analysis]") => {
    $(els).on('change', (e) => {
      enableStrategyFilter(e.currentTarget);
      reloadDrawAllFespCountry(e.currentTarget);
      getLastEvaluations(e.currentTarget);
    });
  }

  // 
  var drawAllFespCountry = () => {
    let url = new URL(`${generateFullUrl($(FILTERS).data('url-last-eval'))}`),
        params = { country: $(COUNTRIES).val() },
        title = '';
    url.search = new URLSearchParams(params).toString();
        
    fetch(url).then((response) => {
      return response.json()
    }).then((json) => {
      $(json).each((k,v) => {
        title =  $("#country-analysis-fesp").find(`option[value=${v.survey_header_id}]`).html();
        $(`#fesp_${v.survey_header_id}`).parent().removeClass('d-none');
        getGraphInformation(v.id, title, false, `fesp_${v.survey_header_id}`);
      });
    });
  };

  //
  var downloadGaps = () => {
    $("#download_gaps").click((e) => {
      window.location = `${$(e.currentTarget).data('url')}.xlsx?country=${$(COUNTRIES).val()}&fesp=${$(FESPS).val()}`;
    });
  };

  var downloadResults = () => {
    $("#download_results").click((e) => {
      window.location = `${$(e.currentTarget).data('url')}.xlsx?country=${$(COUNTRIES).val()}&fesp=${$(FESPS).val()}`;
    });
  };

  document.addEventListener('turbolinks:load', () => {
    if ($(FESPS).length > 0) {
      changeFilters();
      drawAllFespCountry();
      downloadGaps();
      downloadResults();

      $(FESPS).trigger("change");
    }
  });
})();